import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	roleGroups: [],
};

const roleGroupsSlice = createSlice({
	name: 'roleGroups',
	initialState,
	reducers: {
		storeRoleGroups: (state, action) => {
			state.roleGroups = action.payload;
		},
	},
});

export const selectAllRoleGroups = (state) => {
	return state.roleGroups;
};

export const { storeRoleGroups } = roleGroupsSlice.actions;

export default roleGroupsSlice.reducer;
